import { render, staticRenderFns } from "./intervention.vue?vue&type=template&id=31c87173&"
import script from "./intervention.vue?vue&type=script&lang=js&"
export * from "./intervention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports